"use strict";
'kiwi public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _TypingStatusIndicator = _interopRequireDefault(require("./TypingStatusIndicator"));
var _default = exports.default = {
  components: {
    TypingStatusIndicator: _TypingStatusIndicator.default
  },
  props: ['buffer'],
  computed: {
    users() {
      if (this.buffer.isQuery()) {
        // if this is a query return the target as users
        let network = this.$state.getActiveNetwork();
        let user = this.$state.getUser(network.id, this.buffer.name);
        return user ? {
          [user.nick]: user
        } : {};
      }
      return this.buffer.users;
    },
    typingUsers() {
      let myNick = this.$state.getActiveNetwork().nick;
      return Object.values(this.users).filter(u => u.nick !== myNick && u.typingStatus(this.buffer.name).status);
    }
  },
  methods: {
    userColour(user) {
      return user && this.buffer.setting('colour_nicknames_in_messages') ? user.getColour() : '';
    }
  }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["TypingUsersList"]
window._kiwi_exports.components.TypingUsersList = exports.default ? exports.default : exports;
